/* unplugin-vue-components disabled */import script from "./AuthAccess.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthAccess.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/auth-access-magazine.css?vue&type=style&index=0&id=932f32f8&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-932f32f8"]])

export default __exports__